export enum FileUploadStatus {
  Pending = 'pending',
  Error = 'error',
  Success = 'success',
}

export type FileUploadStatusType = `${FileUploadStatus}`;
